exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "@keyframes fadeIn {\n  from {\n    opacity: 0; }\n  to {\n    opacity: 1; } }\n\nspan.error-message {\n  background-color: #ff4542;\n  border-color: #ff4542;\n  border-radius: 0;\n  border-radius: 0.3rem;\n  color: white;\n  font-size: 0.8rem;\n  padding: 5px 10px; }\n  span.error-message .close {\n    padding: 0 5px;\n    cursor: pointer; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/ui/ErrorMessage/ErrorMessage.scss
// module id = 122
// module chunks = 0